// PHOTOS
$('body').on('click', '.change-album-year', function() {
    $(this).addClass('showing');
});



// ADMIN
$('body').on('click', '.album-image .set-as-cover-trigger', function() {
	var $this = $(this);
	var albumImage = $this.parents('.album-image');
    showNotice('processing', 'Processing', null, null);

    $.ajax({
		type : 'POST',
		url : '/photos/'+$('.album').attr('data-album')+'/set-cover',
		data : {
			'album_image': albumImage.attr('data-album_image'),
			'_method': 'PUT',
			'_token': $('meta[name="csrf-token"]').attr('content')
		},
		dataType : 'json',
		success : function(data) {
			console.log(data);
			if(!data.success) {
				showNotice('error', 'Error', data.message, 'Close');
				return false;
			}

			closeModal();
			cancelDots();
			$('.noticeOverlay, .noticeModal').removeClass('visible');

			$('.album-image .set-as-cover-trigger').removeClass('active');
			$this.addClass('active');
		},
		error : function(request) {
			console.log(request.responseText);
		}
	});
    return false;
});


$('body').on('click', '.album-image .rotate-image-left-trigger', function() {
    var $this = $(this);
	var albumImage = $this.parents('.album-image');
    showNotice('processing', 'Processing', null, null);
    
    $.ajax({
		type : 'POST',
		url : '/photo/'+albumImage.attr('data-album_image')+'/rotate-left',
		data : {
			'_method': 'PUT',
			'_token': $('meta[name="csrf-token"]').attr('content')
		},
		dataType : 'json',
		success : function(data) {
			console.log(data);
			if(!data.success) {
				showNotice('error', 'Error', data.message, 'Close');
				return false;
			}

			closeModal();
			cancelDots();
			$('.noticeOverlay, .noticeModal').removeClass('visible');

			albumImage.find('img').attr('src', data.image);
		},
		error : function(request) {
			console.log(request.responseText);
		}
	});
    return false;
});

$('body').on('click', '.album-image .rotate-image-right-trigger', function() {
    var $this = $(this);
	var albumImage = $this.parents('.album-image');
    showNotice('processing', 'Processing', null, null);
    
    $.ajax({
		type : 'POST',
		url : '/photo/'+albumImage.attr('data-album_image')+'/rotate-right',
		data : {
			'_method': 'PUT',
			'_token': $('meta[name="csrf-token"]').attr('content')
		},
		dataType : 'json',
		success : function(data) {
			console.log(data);
			if(!data.success) {
				showNotice('error', 'Error', data.message, 'Close');
				return false;
			}

			closeModal();
			cancelDots();
			$('.noticeOverlay, .noticeModal').removeClass('visible');

			albumImage.find('img').attr('src', data.image);
		},
		error : function(request) {
			console.log(request.responseText);
		}
	});
    return false;
});

$('body').on('click', '.album-image .delete-image-trigger', function() {
    var $this = $(this);
	var albumImage = $this.parents('.album-image');
    showNotice('processing', 'Processing', null, null);
    
    $.ajax({
		type : 'POST',
		url : '/photo/'+albumImage.attr('data-album_image'),
		data : {
			'_method': 'DELETE',
			'_token': $('meta[name="csrf-token"]').attr('content')
		},
		dataType : 'json',
		success : function(data) {
			console.log(data);
			if(!data.success) {
				showNotice('error', 'Error', data.message, 'Close');
				return false;
			}

			closeModal();
			cancelDots();
			$('.noticeOverlay, .noticeModal').removeClass('visible');

			albumImage.remove();
		},
		error : function(request) {
			console.log(request.responseText);
		}
	});
    return false;
});

$('body').on('keydown', '.album-image .image-sort input', function(e) {
    if(e.keyCode != 13) {
    	return;
    }

    var $this = $(this);
	var albumImage = $this.parents('.album-image');
    showNotice('processing', 'Processing', null, null);
    
    $.ajax({
		type : 'POST',
		url : '/photo/'+albumImage.attr('data-album_image')+'/update-sort-order',
		data : {
			'sort_order': $this.val(),
			'_method': 'PUT',
			'_token': $('meta[name="csrf-token"]').attr('content')
		},
		dataType : 'json',
		success : function(data) {
			console.log(data);
			if(!data.success) {
				showNotice('error', 'Error', data.message, 'Close');
				return false;
			}

			closeModal();
			cancelDots();
			$('.noticeOverlay, .noticeModal').removeClass('visible');

			$this.blur();
		},
		error : function(request) {
			console.log(request.responseText);
		}
	});
});

var albumShifting;
$(document).on('keyup keydown', function(e){albumShifting = e.shiftKey;});


$('body').on('keydown', '.album-image [name="caption"]', function(e) {
    if(e.keyCode != 13) {
    	return;
    }

    if(albumShifting) {
    	return;
    }

    e.preventDefault();
    var $this = $(this);
	var albumImage = $this.parents('.album-image');
    showNotice('processing', 'Processing', null, null);
    
    $.ajax({
		type : 'POST',
		url : '/photo/'+albumImage.attr('data-album_image')+'/update-caption',
		data : {
			'caption': $this.val(),
			'_method': 'PUT',
			'_token': $('meta[name="csrf-token"]').attr('content')
		},
		dataType : 'json',
		success : function(data) {
			console.log(data);
			if(!data.success) {
				showNotice('error', 'Error', data.message, 'Close');
				return false;
			}

			closeModal();
			cancelDots();
			$('.noticeOverlay, .noticeModal').removeClass('visible');

			$this.blur();
		},
		error : function(request) {
			console.log(request.responseText);
		}
	});
});